<script setup lang="ts">
import SiteMapStructuresTable from '@/components/eos/site-map/SiteMapStructuresTable.vue'
</script>

<template>
  <SiteMapStructuresTable> </SiteMapStructuresTable>
</template>
